/**
 * EmployeeStatusService
 * Service for EmployeeStatus entity operations
 * Route: api/employeestatus
 */
import { CrudService } from '../base/CrudService';
/**
 * EmployeeStatusService
 * Handles employee status CRUD operations
 */
export class EmployeeStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EmployeeStatusService.DEFAULT_SERVICE_PATH,
            basePath: EmployeeStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
EmployeeStatusService.DEFAULT_SERVICE_PATH = 'hr';
EmployeeStatusService.BASE_PATH = 'api/employeestatus';
//# sourceMappingURL=EmployeeStatusService.js.map